import LogoBar from 'components/LogoBar'
import React, { useCallback, useEffect, useState } from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import './TopNavigation.css'
import TopMenuExpandButton from './TopMenuExpandButton'
import TopNavExpanded from './TopNavExpanded'
import { useAuth } from 'auth/AuthProvider'
import { PAGE_URL_CATALOG } from 'SiteURLs'
import { useLocation, useNavigate } from 'react-router-dom'
import TopNavLinksAuth from './TopNavLinksAuth'
import TopNavLinksNotAuth from './TopNavLinksNotAuth'

const TopNavigation: React.FC = () => {
  const auth = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const [currentHash, setCurrentHash] = useState('/')
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    setCurrentHash('#' + location.pathname)
  }, [location])

  const handleToggle = useCallback(() => {
    setIsExpanded(!isExpanded)
  }, [isExpanded])

  const handleLogout = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      auth.signout(() => {
        navigate(PAGE_URL_CATALOG)
        setIsExpanded(false)
      })
    },
    [auth, navigate]
  )

  const handleLogin = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()

      setIsExpanded(false)
      auth.showSignInDialog()
    },
    [auth]
  )

  return (
    <Navbar expand='xl' className='header-area top-menu-fixed'>
      <Container>
        <div className='d-flex'>
          <Navbar.Brand href='https://freedom-vrn.ru/'>
            <LogoBar />
          </Navbar.Brand>
          <TopMenuExpandButton expanded={isExpanded} onToggle={handleToggle} />
        </div>

        <Navbar.Collapse id='navbar-nav' className='justify-content-start mx-4'>
          <Nav>
            {auth.user ? (
              <TopNavLinksAuth currentHash={currentHash} onLogout={handleLogout} />
            ) : (
              <TopNavLinksNotAuth currentHash={currentHash} onLogin={handleLogin} />
            )}
          </Nav>
        </Navbar.Collapse>

        {/* <Navbar.Collapse id='navbar-nav' className='justify-content-end'>
          <Nav>
            <a className='nav-link' href='tel:+7(473)260-60-60'>
              (473) 260-60-60
            </a>
            <BlueButton onClick={handleRecall}>Обратный звонок</BlueButton>
          </Nav>
        </Navbar.Collapse> */}
      </Container>
      <TopNavExpanded
        user={auth.user}
        isExpanded={isExpanded}
        onClick={handleToggle}
        onLogout={handleLogout}
        onLogin={handleLogin}
      />
    </Navbar>
  )
}
export default TopNavigation
